/**
 * Global authentication handler to coordinate between API client and AuthContext
 * This allows the API interceptor to trigger logout when receiving 401 errors
 */

type LogoutHandler = () => Promise<void>;

class AuthHandler {
  private logoutHandler: LogoutHandler | null = null;

  /**
   * Register logout handler from AuthContext
   */
  setLogoutHandler(handler: LogoutHandler) {
    this.logoutHandler = handler;
  }

  /**
   * Trigger logout (called by API interceptor on 401)
   */
  async triggerLogout(): Promise<void> {
    console.log("Triggering logout from AuthHandler");
    if (this.logoutHandler) {
      await this.logoutHandler();
    } else {
      console.warn('No logout handler registered');
    }
  }

  /**
   * Clear the handler on unmount
   */
  clearLogoutHandler() {
    this.logoutHandler = null;
  }
}

// Export singleton instance
export const authHandler = new AuthHandler();
